<template>
  <div class="af-card">
    <p class="is-size-4 has-text-weight-bold">
      <span v-if="action === 'registration'">{{
        $t("af:mortgage_welcome.registration.title")
      }}</span>
      <span v-else>{{ $t("af:mortgage_welcome.login.title") }}</span>
    </p>

    <b-button
      id="WelcomeButtonEmailLogin"
      class="mb-4"
      @click="navigateEmail"
      icon-left="envelope"
    >
      {{ $t("af:mortgage_welcome.button.email_login") }}
    </b-button>
    <b-button
      id="WelcomeButtonPhoneLogin"
      @click="navigatePhone"
      icon-left="phone-alt"
    >
      {{ $t("af:mortgage_welcome.button.phone_login") }}
    </b-button>

    <div class="change-action mt-5">
      <p v-if="action === 'registration'">
        <span>{{ $t("af:mortgage_welcome.registration.footer.title") }}</span>
        <router-link id="WelcomeButtonLogin" class="ml-2" to="/mortgage/login">
          {{ $t("af:mortgage_welcome.registration.footer.button.to_login") }}
        </router-link>
      </p>

      <p v-else>
        <span>{{ $t("af:mortgage_welcome.login.footer.title") }}</span>
        <router-link
          id="WelcomeButtonRegistration"
          class="ml-2"
          to="/mortgage/registration"
          >{{
            $t("af:mortgage_welcome.login.footer.button.to_registration")
          }}</router-link
        >
      </p>
    </div>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";

export default {
  name: "MortgageWelcome",
  // title: "af:page.mortgage_welcome.title",
  data() {
    return {
      action: null, // registration | login
    };
  },
  watch: {
    "$route.meta.action": {
      immediate: true,
      handler: function () {
        this.action = this.$route.meta.action;
      },
    },
  },
  methods: {
    navigateEmail() {
      if (this.action === "registration") {
        this.$router.push({
          name: "MortgageEmailRegistration",
        });
      } else {
        this.$router.push({
          name: "MortgageEmailLogin",
        });
      }
    },
    navigatePhone() {
      if (this.action === "registration") {
        this.$router.push({
          name: "MortgagePhoneRegistration",
        });
      } else {
        this.$router.push({
          name: "MortgagePhoneLogin",
        });
      }
    },
  },
  updated() {
    if (this.action === "registration") {
      document.title = i18n.t("af:page.registration.title");
    }
    if (this.action === "login") {
      document.title = i18n.t("af:page.login.title");
    }
  },
};
</script>

<style scoped lang="scss">
.af-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  height: 100%;

  display: flex;
  flex-direction: column;
}

@media only screen and (min-width: 769px) {
  .af-card {
    padding: 32px 36px;
  }
}
</style>
